import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import { ElementaryStreamTypes } from "hls.js/dist/hls.js";

class FairDetailsStore {
  loading = false;
  total = 0;
  taxiParameterList = [];
  vehicleTypeArr = [];
  totaltarrifVehicles = 0;
  tarrifVehicles = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      taxiParameterList: observable,
      vehicleTypeArr: observable,
      totaltarrifVehicles: observable,
      tarrifVehicles: observable,
      loadData: action,
      deleteRecord: action,
      vehicleTypeData: action,
      addData: action,
      getFareData: action,
      getFareGridData: action,
      getVersion: action,
      generateCRC32: action,
      downloadVehicleTarrif: action,

      sendCommand: action,
      deleteGridRecord: action,
      downloadJson: action,
      saveTarrif: action,
      getTarrif: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, page }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      page: page,
    };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .get(config.NodeUrl + "/taxi/getParameterDetails", {
          params: postData,
        });
      console.log(response?.data?.data);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=taxi&a=getParametersDetails",
          "postData=" + base64Input,
        );
    }

    this.taxiParameterList = response?.data?.data?.TaxiParametersData;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async vehicleTypeData(companyId) {
    var postData = { companyId: companyId, fairType: null };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .get(config.NodeUrl + "/taxi/getVehicleType", {
          params: postData,
        });
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=taxi&a=getVehicleType", "postData=" + base64Input);
    }

    this.vehicleTypeArr = response.data.data;
  }

  async addData(fareDetails) {
    var postData = fareDetails;
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")//3035
        // .post("http://localhost:3035/taxi/Update", postData);
        .post(config.NodeUrl + "/taxi/Update", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=taxi&a=update", "postData=" + base64Input);
    }

    return response.data;
  }

  async getFareData({ parameterId, companyId }) {
    var postData = {
      mId: parameterId,
      companyId: companyId,
      limit: 1,
      offset: 0,
    };
    // console.log(postData)
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .get(config.NodeUrl + "/taxi/getParameterDetails", {
          params: postData,
        });
      console.log("object", response?.data?.data);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=taxi&a=getParametersDetails",
          "postData=" + base64Input,
        );
    }
    return response?.data?.data?.TaxiParametersData[0];
  }

  async getFareGridData(Id) {
    var postData = {
      Id: Id,
    };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .get(config.NodeUrl + "/taxi/getGridData", {
          params: postData,
        });
      console.log("response", response?.data?.data);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=taxi&a=getGridData", "postData=" + base64Input);
    }
    return response?.data?.data;
  }

  async deleteRecord({ parameterId }) {
    const postData = { calenderId: null, parameterId: parameterId };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .delete(config.NodeUrl + "/taxi/delete", {
          params: postData,
        });
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=taxi&a=delete", "postData=" + base64Input);
    }

    return response;
  }
  async getVersion(postData) {
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      // .post("index.php?c=taxi&a=getVersion", "postData=" + base64Input);
      .get(config.NodeUrl + "/taxi/getVersion", postData);
    // .get("http://localhost:3035/taxi/getVersion", postData);
    console.log(response?.data?.data);
    return response?.data?.data;
  }

  async generateCRC32(postData) {
    console.log(postData);
    const base64Input = await base64_encode(JSON.stringify(postData));

    var response = await postApi
      .getClient()
      // .post("http://localhost:3035/taxi/getcrc32Value", postData);
      .post(config.NodeUrl + "/taxi/getcrc32Value", postData);
    // .post("index.php?c=taxi&a=getcrc32Value", "postData=" + base64Input);
    console.log(response?.data?.data);
    return response?.data?.data;
  }
  async downloadJson(companyId, fareId) {
    window.open(
      `https://sa.trackeazy.com/api//app/index.php?c=taxi&a=downloadJsonData&cid=${companyId}&fareId=${fareId}`,
      "_blank",
    );
    //  window.open(
    //   `http://localhost:3035/taxi/downloadJsondata?cid=${companyId}`,
    //   "_blank"
    // );
  }
  async saveTarrif(data) {
    console.log(data);

    // console.log(postData)
    var response = await postApi
      .getClient()
      // .post("http://localhost:3035/taxi/saveTarrif", data);
      .post(config.NodeUrl + "/taxi/saveTarrif", data);
    return response?.data;
  }

  async getTarrif(data) {
    console.log(data);
    this.loading = true;
    const response = await postApi
      .getClient()
      // .get("http://localhost:3035/taxi/getTarrif", {
      .get(config.NodeUrl + "/taxi/getTarrif", {
        params: data,
      });
    console.log(response?.data?.TotalCount);
    console.log(response?.data?.tarrifVehicles);
    this.totaltarrifVehicles = response?.data?.TotalCount;
    this.tarrifVehicles = response?.data?.tarrifVehicles;
    this.loading = false;
    return response?.data;
  }

  async sendCommand(data) {
    this.loading = true;
    const base64Input = await base64_encode(JSON.stringify(data));

    const response = await postApi
      .getClient()
      .post("index.php?c=taxi&a=sendCommand", "postData=" + base64Input);

    // .post("http://localhost:3035/taxi/sendCommand", data);
    this.loading = false;
    return response?.data;
  }

  deleteGridRecord = async (data) => {
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .delete(config.NodeUrl + `/vehicle-maintenance/deleteMaintenance`, {
          params: data,
        });
    } else {
      const base64Input = await base64_encode(JSON.stringify(data));
      var response = await postApi
        .getClient()
        .post("index.php?c=taxi&a=deleteGridRecord", "postData=" + base64Input);
    }

    return response;
  };

  async deleteTariffrecord(id) {
    const postData = {
      id: id,
    };
    console.log(postData);

    const base64Input = await base64_encode(JSON.stringify(postData));

    // .post("http://localhost:3035/taxi/sendCommand", data);
    var response = await postApi
      .getClient()
      // .delete("http://localhost:3035" + "/taxi/deleteTariff", {
      .delete(config.NodeUrl + "/taxi/deleteTariff", {
        params: {
          id: id,
        },
      });

    return response;
  }
  async downloadVehicleTarrif(data) {
    window.open(
      `https://sa.trackeazy.com/api//app/index.php?c=taxi&a=downloadVehicleTarrif&otaId=${data.otaId}`,
      "_blank",
    );
  }
}
export default FairDetailsStore;
